import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
interface iRoundStatusCounts {
    COMPLETED : number;
    FAILED : number;
    not_started : number;
    RUNNING : number;
}

interface iRoundLibraryLists {
    COMPLETED : any[];
    FAILED : any[];
    not_started : any[];
    RUNNING : any[];
}

interface iWholeWorkflowResponse {
    library_count : number;
    round_statuses : Record<string, Record<string, iRoundStatusCounts>>;
    round_library_lists?: Record<string, Record<string, iRoundLibraryLists>>;
}

export interface iWholeWorkflowState{
    response: iWholeWorkflowResponse | null;
    isLoading: boolean;
    message: string | null;
}


const initialResponse: iWholeWorkflowResponse = {
    library_count: 0,
    round_statuses: {},
    round_library_lists: {}
};

const initialState: iWholeWorkflowState = {
    response: initialResponse,
    isLoading: false,
    message: "",
};

export const wholeWorkflowAPI = createAsyncThunk(
  "wholeWorkflowAPI",
  async (_, { rejectWithValue }) => {
    try {
      
      const pathParam = '/dashboard/whole-workflow/';
      const djangoEndpoint = getDjangoEndpoint();
      const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  },
  {
    // Layout Drawer와 Dashboard가 같은 시점에 마운트돼도 진행 중인 요청은 재실행하지 않음.
    condition: (_, { getState }) => {
      const state = getState() as { dashboardHistory?: iWholeWorkflowState };
      return !state.dashboardHistory?.isLoading;
    },
  }
);



const wholeWorkflowSlice = createSlice({
  name: "wholeWorkflow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(wholeWorkflowAPI.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })

        .addCase(wholeWorkflowAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(wholeWorkflowAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        }
      );
  }
});

export default wholeWorkflowSlice.reducer;
